import { useEffect, useRef } from 'react';
import { ConfettiFillIcon } from '@zep-us/zus-icons';
import { useRouter } from 'next/router';
import { Trans, useTranslation } from 'next-i18next';
import '@/shared/features/phone-verification/tracking/events.quiz-trial';
import { trackEvent } from '@zep/logger/tracking';
import { useLocale } from '@/hooks';
import { PromotionModal } from '@/shared/components/PromotionModal';
interface PhoneVerificationBannerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDismiss: () => Promise<void>;
  onDismissForToday: () => void;
  onOpen?: VoidFunction;
  source?: 'signup' | 'banner_modal';
}
export const PhoneVerificationBannerModal = ({
  isOpen,
  onClose,
  onDismiss,
  onDismissForToday,
  onOpen,
  source = 'banner_modal'
}: PhoneVerificationBannerModalProps) => {
  const router = useRouter();
  const {
    t
  } = useTranslation(['common']);
  const {
    locale
  } = useLocale();
  const hasTrackedView = useRef(false);
  const imageUrl = locale === 'ko' ? '/assets/phone_verification_event_banner.webp' : '/assets/phone_verification_event_banner_en.webp';
  useEffect(() => {
    if (isOpen && !hasTrackedView.current) {
      hasTrackedView.current = true;
      onOpen?.();
      trackEvent('phone_verification_banner_modal_view', {
        from: source
      });
      trackEvent('quiz_trial_prompt_view', {
        trial_source: source,
        surface: 'automatic_modal',
        trial_region: 'kr',
        trial_type: 'phone_verification'
      });
    }
  }, [isOpen, onOpen, source]);
  const handleCtaClick = () => {
    trackEvent('phone_verification_banner_modal_cta_click', {
      from: source
    });
    trackEvent('quiz_trial_prompt_click', {
      trial_source: source,
      surface: 'automatic_modal',
      destination: 'verification_phone',
      trial_region: 'kr',
      trial_type: 'phone_verification'
    });
    onClose();
    void router.push({
      pathname: '/verification-phone',
      query: {
        from: source,
        trialSource: source,
        callbackUrl: router.asPath
      }
    });
  };
  const handleDismissClick = () => {
    trackEvent('phone_verification_banner_modal_dismiss', {
      from: source
    });
    trackEvent('quiz_trial_prompt_close', {
      trial_source: source,
      surface: 'automatic_modal',
      reason: 'dismiss_for_today',
      trial_region: 'kr',
      trial_type: 'phone_verification'
    });
    onDismissForToday();
    void onDismiss();
  };
  return <PromotionModal isOpen={isOpen} onClose={() => void onDismiss()} title={<Trans t={t} i18nKey="phoneVerify.bannerModal.title" components={{
    br: <br />
  }} />} description={<Trans t={t} i18nKey="phoneVerify.bannerModal.description" components={{
    br: <br />
  }} />} imageUrl={imageUrl} badge={{
    icon: <ConfettiFillIcon size="2xs" />,
    label: t('global.event')
  }} primaryLabel={t('phoneVerify.bannerModal.confirmButton')} onPrimaryClick={handleCtaClick} secondaryLabel={t('phoneVerify.bannerModal.dismissButton')} onSecondaryClick={handleDismissClick} data-sentry-element="PromotionModal" data-sentry-component="PhoneVerificationBannerModal" data-sentry-source-file="PhoneVerificationBannerModal.tsx" />;
};